import type { Job, JobItem, Payment } from '@kanda-libs/ks-frontend-services';
import { getLatestPayment } from './Payments-functions';

export const checkJobIsCustom = (job: Job): boolean => {
  const items = job.job_items;
  const itemsAreCustom = items.map(
    (item: JobItem) => item.style === 'custom' && Boolean(item.quote_document),
  );
  return itemsAreCustom.some((val) => val);
};

export const checkJobPaidByOB = (job?: Job): boolean => {
  if (!job) return false;
  const { payments } = job;
  const customerOption = job.customer_options?.checkout_option;
  if (!customerOption || !payments || payments.length === 0) return false;
  if (customerOption !== 'pay_by_bank') return false;
  const bankPayments = payments.filter(
    (p) => p.payment_option.payment_method === 'bank',
  );
  const bankPayment = getLatestPayment(bankPayments);
  if (!bankPayment) return false;
  return bankPayment.status === 'paid';
};

export const getJobDepositPayment = (job?: Job): Payment | undefined => {
  if (!job) return undefined;
  const depositAmount = job?.customer_options?.deposit_value?.amount;
  if (depositAmount === undefined) return undefined;
  const priceMatched = job.payments
    ?.filter((p) => p.payment_option.payment_method !== 'loan')
    ?.filter((p) => p.payment_option.amount.amount === depositAmount);
  if (!priceMatched || priceMatched.length === 0) return undefined;
  if (priceMatched.length === 1) return priceMatched[0];
  return priceMatched.sort(
    (p1, p2) =>
      new Date(p2.metadata?.created_at ?? 0).getTime() -
      new Date(p1.metadata?.created_at ?? 0).getTime(),
  )[0];
};

export const checkJobChangesRequested = (job: Job): boolean => {
  const { current_step: currentStep } = job;
  if (!currentStep) return false;
  return currentStep.name === 'checkout_quote_changes_requested';
};
